import { ref, computed} from 'vue';
import { defineStore } from 'pinia';
import { criarQuestoesIA } from '@/api/criarQuestoesIA';
import {carregarDisciplinas} from '@/api/fetchDisciplinas';
import { useStore as useVuexStore } from 'vuex';
import {  carregarQuestoes, carregarNiveisComplexidade } from '@/api/fetchQuestoes';
import { carregarAvaliacoes } from '@/api/fetchAvaliacoes';

export const useRecursosDidaticosStore = defineStore('recursosDidaticos', () => {
    const user = ref(null);
    const loading = ref(false);
    const vuexStore = useVuexStore();
    user.value = vuexStore.state.userSession.user;
    const idUsuario = ref(user.value.idU);
    const gerenciarListaQuestoesVisible = ref(false);
    const apenasMeusRecursos = ref(true)
    const questoes = ref([]);
    const paginaAtualQuestoes = ref(1);
    const carregandoQuestoes = ref(false);
    const semMaisQuestoes = ref(false);
    const disciplinaSelecionada = ref(user.value.disciplina);
    const conceitosSelecionados = ref([]);
    const tiposQuestoesSelecionadas = ref(null);
    const nivelComplexidadeSelecionado = ref(null);
    const disciplinas = ref([]);
    const conceitos = ref([]);
    const tiposQuestoes = ref([
        { nome: "Multipla escolha", value: 1 },
        { nome: "Dissertativa", value: 2 },
    ]);
    const niveisComplexidade = ref([]);
    const textoPesquisa = ref('');
    const tabAtiva = ref(0);

    

    async function carregarDadosIniciais(){
        loading.value = true;
        carregandoQuestoes.value = true;
        questoes.value = await carregarQuestoes(disciplinaSelecionada.value, apenasMeusRecursos.value ? idUsuario.value : null);
        if (questoes.value.length < 10) semMaisQuestoes.value = true;
        carregandoQuestoes.value = false;
        conceitos.value = extrairConceitosUnicos(questoes.value);
        niveisComplexidade.value = await carregarNiveisComplexidade();
        disciplinas.value = await carregarDisciplinas();
        avaliacoes.value = await carregarAvaliacoes(disciplinaSelecionada.value, apenasMeusRecursos.value ? idUsuario.value : null);
        loading.value = false;
    }
    
    async function filtrarQuestoes(){
        semMaisQuestoes.value = false;
        questoes.value = await carregarQuestoes(disciplinaSelecionada.value, apenasMeusRecursos.value ? idUsuario.value : null, nivelComplexidadeSelecionado.value, tiposQuestoesSelecionadas.value, textoPesquisa.value, conceitosSelecionados.value);
    }

    async function carregarMaisQuestoes() {
        console.log('carregarMaisQuestoes')
        if(carregandoQuestoes.value || semMaisQuestoes.value) return;
        carregandoQuestoes.value = true;
        paginaAtualQuestoes.value += 1;
        let data = await carregarQuestoes(disciplinaSelecionada.value, apenasMeusRecursos.value ? idUsuario.value : null, nivelComplexidadeSelecionado.value, tiposQuestoesSelecionadas.value, textoPesquisa.value, conceitosSelecionados.value, paginaAtualQuestoes.value);
        if(data.length < 10) semMaisQuestoes.value = true;
        questoes.value = questoes.value.concat(data);
        console.log('teste')
        carregandoQuestoes.value = false;
    }

    async function filtrarAvaliacoes() {
        avaliacoes.value = await carregarAvaliacoes(disciplinaSelecionada.value, apenasMeusRecursos.value ? idUsuario.value : null); 
    }

    function extrairConceitosUnicos(itens) {
        const conceitosSet = new Set();

        itens.forEach(item => {
            if (item.conceitos) {
                const conceitosArray = item.conceitos.split(',').map(conceito => conceito.trim().toLowerCase());
                conceitosArray.forEach(conceito => conceitosSet.add(conceito));
            }
        });

        return Array.from(conceitosSet);
    }

    const avaliacao = ref({ id: null, proprietario: null, titulo: '', questoes: [], adicionarQuestoes: false });// se trata da avaliação que foi selecionada ou cria
    const questoesAdicionadasNaAvaliacao = ref([]); // se trata das questões que são adicionadas á uma avaliação
    const avaliacoes = ref([]); // se trata da lista de avaliações que há no banco de dados
    

    // AINDA FALTA PARA CONCLUIR
    // é minha
    // editar questões
    // duplicar questões
    // deletar questões

    // não sou proprietário
    // duplicar questão
    
    carregarDadosIniciais();

    return { questoes, loading, user, idUsuario, gerenciarListaQuestoesVisible, disciplinas, conceitos, tiposQuestoes, niveisComplexidade, disciplinaSelecionada, conceitosSelecionados, tiposQuestoesSelecionadas, nivelComplexidadeSelecionado, textoPesquisa, tabAtiva, filtrarQuestoes, filtrarAvaliacoes, avaliacao,  avaliacoes, questoesAdicionadasNaAvaliacao, apenasMeusRecursos, paginaAtualQuestoes, carregandoQuestoes, carregarMaisQuestoes }
})
